var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"storyItem"},[_c('router-link',{attrs:{"to":{
      name: 'CultureStoryDetail',
      query: { id: _vm.item.msId, page: _vm.currentPage }
    }}},[_c('div',{staticClass:"clickable"},[_c('div',{staticClass:"storyItem__img",style:(`background-image: url(${_vm.baseURL}${_vm.item.image})`),attrs:{"alt":`${_vm.item.title}`}}),_c('h3',{staticClass:"storyItem__title"},[_vm._v(_vm._s(_vm.item.title))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }